import { defineComponent, openBlock, createElementBlock, createCommentVNode, createElementVNode, unref, createVNode, toDisplayString, Fragment, renderList, normalizeClass } from 'vue';
import { UiIcon } from '../../../icon/index.mjs';
import { useComposable } from './src/composable.mjs';
import { UiPickerEmits } from './index.mjs';

const _hoisted_1 = { class: "ui-date-picker-candidate ui-picker-month" };
const _hoisted_2 = { class: "ui-date-picker-candidate-header" };
const _hoisted_3 = { class: "ui-date-picker-candidate-controls ui-date-picker-candidate-left-controls" };
const _hoisted_4 = { class: "ui-date-picker-candidate-context" };
const _hoisted_5 = { class: "ui-date-picker-candidate-year" };
const _hoisted_6 = { class: "ui-date-picker-candidate-controls ui-date-picker-candidate-right-controls" };
const _hoisted_7 = { class: "ui-date-picker-candidate-content" };
const _hoisted_8 = { class: "ui-date-picker-candidate-content-container" };
const _hoisted_9 = ["onClick"];
var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "index",
  emits: UiPickerEmits,
  setup(__props, { expose: __expose, emit: __emit }) {
    const emits = __emit;
    const { refs, methods, disposes } = useComposable(emits);
    const { months, year } = refs;
    const { changeDate, changeMonth } = methods;
    const { init, receiveDayClassName } = disposes;
    __expose({ init });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createCommentVNode(" * \u6708\u4EFD\u9009\u62E9\u5668\u5934\u90E8 "),
        createElementVNode("div", _hoisted_2, [
          createCommentVNode(" * \u5DE6\u4FA7\u63A7\u5236\u5668 "),
          createElementVNode("div", _hoisted_3, [
            createCommentVNode(" * \u5E74\u4EFD\u63A7\u5236\u5668 "),
            createElementVNode("div", {
              class: "ui-date-picker-candidate-control ui-date-picker-candidate-year-control",
              onClick: _cache[0] || (_cache[0] = ($event) => unref(changeDate)({ year: unref(year) - 1 }))
            }, [
              createVNode(unref(UiIcon), { name: "arrow-double" })
            ])
          ]),
          createCommentVNode(" * \u65E5\u671F\u5E74\u6708\u4FE1\u606F "),
          createElementVNode("div", _hoisted_4, [
            createCommentVNode(" * \u5E74\u4EFD\u4FE1\u606F "),
            createElementVNode(
              "div",
              _hoisted_5,
              toDisplayString(unref(year)) + "\u5E74",
              1
              /* TEXT */
            )
          ]),
          createCommentVNode(" * \u53F3\u4FA7\u63A7\u5236\u5668 "),
          createElementVNode("div", _hoisted_6, [
            createCommentVNode(" * \u5E74\u4EFD\u63A7\u5236\u5668 "),
            createElementVNode("div", {
              class: "ui-date-picker-candidate-control ui-date-picker-candidate-year-control",
              onClick: _cache[1] || (_cache[1] = ($event) => unref(changeDate)({ year: unref(year) + 1 }))
            }, [
              createVNode(unref(UiIcon), { name: "arrow-double" })
            ])
          ])
        ]),
        createCommentVNode(" * \u6708\u671F\u9009\u62E9\u5668\u5185\u5BB9 "),
        createElementVNode("div", _hoisted_7, [
          createElementVNode("div", _hoisted_8, [
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList(unref(months), (value) => {
                return openBlock(), createElementBlock("div", {
                  class: normalizeClass(["ui-picker-candidate", unref(receiveDayClassName)(value)]),
                  onClick: ($event) => unref(changeMonth)(value)
                }, toDisplayString(value + 1) + "\u6708", 11, _hoisted_9);
              }),
              256
              /* UNKEYED_FRAGMENT */
            ))
          ])
        ])
      ]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=index.vue2.mjs.map
